import React from 'react';
import times from 'lodash/times';
import styled from 'styled-components';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../CommonComponents/OPL/Shimmer/Shimmer';

const Grid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 24,
  padding: 24,
});

export const MyAccountLoading = () => {
  return (
    <>
      <Grid>
        {times(8).map(key => (
          <Box key={key}>
            <Shimmer width="30%" height={16} mb="4" />
            <Shimmer width="100%" height={36} mb="4" />
          </Box>
        ))}
      </Grid>

      <Box display="flex" p="24">
        <Shimmer width={100} height={36} mr="auto" />

        <Shimmer width={100} height={36} mr="8" />
        <Shimmer width={100} height={36} />
      </Box>
    </>
  );
};
